export default __webpack_public_path__ + "static/media/magie.5b6c9dd9.png";